export enum PlayTypeEnum {
	FUN = "fun",
	MONEY = "money",
}
